.infoContainer {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  padding: 20px;
}

.imageContainer {
  display: flex;
  margin-right: 20px;
  justify-content: center;
}

.details {
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
}
